import {router} from "expo-router";
import Card from "@/lib/components/Card";
import {Group, Membership} from "@/lib/types";
import AvatarBox from "@/lib/components/AvatarBox";
import PrimaryText from "@/lib/components/PrimaryText";
import {pluralize} from "@/lib/language";
import {useMemo} from "react";

type Props = {
    group: Group,
}

// Preview group card for lists.
export default function GroupCard({group}: Props) {
    function onPress() {
        router.navigate(`/s/${group.group_id}`);
    }

    const members = useMemo(() => {
        if (!group) {
            return [];
        }
        return group.members.filter(m => (
            m.status === Membership.ADMINISTRATOR ||
            m.status === Membership.MODERATOR ||
            m.status === Membership.MEMBER
        ));
    }, [group]);

    return (
        <Card onPress={onPress}
              image_url={group.image_url}
              color={group.color}
              contrast_color={group.contrast_color}
              title={group.name}>
            {group.public && <PrimaryText>Offentlig samfunn</PrimaryText>}
            {!group.public && <PrimaryText>Privat samfunn</PrimaryText>}
            {group.invited_by && group.membership_status === Membership.INVITED &&
                <AvatarBox border={false} avatars={[group.invited_by]} color={group.color}>
                    <PrimaryText>{group.invited_by.username} har invitert deg</PrimaryText>
                </AvatarBox>
            }
            {members.length > 0 &&
                <AvatarBox
                    avatars={members.map(m => m.avatar)}
                    color={group.color}
                    border={false}
                    numItems={6}
                >
                    <PrimaryText>{pluralize(members.length, "medlem", "medlemmer")}</PrimaryText>
                </AvatarBox>
            }
        </Card>
    )
}